<div class="w-full flex flex-col">
    <div class="NgxEditor__Wrapper">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          [(ngModel)]="rawWyg"
          [disabled]="false"
          [placeholder]="placeholder"
          (focusOut)="updatedWig($event)"
        ></ngx-editor>
      </div>
</div>